/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateBotStrategyByIdOptions,
  CreateBotStrategyByIdResponses,
} from '../types/CreateBotStrategyById'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Create a new bot strategy. Admin-only.
 * @summary Create Bot Strategy
 * {@link /v1/bot/strategies}
 */
export function createBotStrategyById<ThrowOnError extends boolean = true>(
  options: Options<CreateBotStrategyByIdOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateBotStrategyByIdResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/bot/strategies',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateBotStrategyByIdResponses, ThrowOnError>>,
  )
}
